import { CheckCircleFilled } from '@ant-design/icons'
import { Badge } from 'antd'
import React from 'react'
import { useHistory } from 'react-router'

import { EventInfoFragment } from '@/generated/graphql'
import { EventCard } from '@/modules/calendar/event-card/event-card.component'
import { routes } from '@/routes'

import s from './date-cell.module.less'

export const DateCell: React.FC<{ data: EventInfoFragment[]; date: string }> = ({ data, date }) => {
  const history = useHistory()
  const orderedData = data.slice().sort((a, b) => new Date(a.startTime).getTime() - new Date(b.startTime).getTime())
  return (
    <div className={s.cell} key={date}>
      {orderedData.map((data) => (
        <div key={data.eventId} className={s.event} onClick={() => history.push(routes.posts.page(data.postId))}>
          <EventCard data={data}>
            {data.isParticipated ? (
              <span>
                <CheckCircleFilled style={{ color: '#6FA960', marginRight: 6 }} />
                {data.topic}
              </span>
            ) : (
              <Badge key={data.eventId} color={data.isInterested ? '#F34616' : 'purple'} text={data.topic} />
            )}
          </EventCard>
        </div>
      ))}
    </div>
  )
}
